import actions from './actions';

const initState = {
	dataReOrderParagraph: [],
	readReOrderParagraph: {},
	totalItems: 0,
	loading: false,
};

export default function learnerReducer(state = initState, action) {
	switch (action.type) {
		case actions.GET_REORDER_PARAGRAPH:
			return { ...state, totalItems: 0, loading: true };
		case actions.GET_REORDER_PARAGRAPH_SUCCESS:
			let { data, totalItems } = action.payload;
			let res = data ? data : [];
			return { ...state, dataReOrderParagraph: res, totalItems, loading: false };

		case actions.GET_REORDER_PARAGRAPH_DETAIL:
			return { ...state, loading: true, totalItems: 0 };
		case actions.GET_REORDER_PARAGRAPH_DETAIL_SUCCESS: {
			let { data } = action.payload;
			let res = data ? data : {};
			return { ...state, readReOrderParagraph: res, loading: false };
		}

		case actions.READING_LOADING_FALSE: {
			return { ...state, loading: false };
		}

		default:
			return state;
	}
}
